import * as React from "react"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TablePagination from "@mui/material/TablePagination"
import TableRow from "@mui/material/TableRow"
import { ICCTableColumn, ICCTableData } from "../../util/interface"
import { createUseStyles, useTheme } from "react-jss"
import { ccDataSelector } from "./DataMetaDataSlice"
import { useAppSelector } from "../../util/hooks"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { ABBREVIATE_NUMBER } from "../../util/CommonMethods"
import { v4 as uuidv4 } from "uuid"
const useStyles = createUseStyles({
  wrapper: {},
  root: {
    "& .MuiTableCell-head": {
      backgroundColor: "#fbfbfb",
    },
  },
  borderRight: {
    borderRight: "1px solid lightgray",
  },
  borderBottom: {
    borderBottomColor: "transparent !important",
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
  },
  subHeading: {
    color: "#606060",
    fontSize: 14,
    fontWeight: 600,
  },
})

const columns: ICCTableColumn[] = [
  { id: "BASE_TABLE", label: "Base Table Name", minWidth: 140, align: "left" },
  {
    id: "baseTableColumn",
    label: "Column",
    minWidth: 150,
    align: "left",
  },
  {
    id: "SUM_IN_BASE_TABLE",
    label: "Sum",
    minWidth: 100,
    align: "left",
    format: (value: number) => ABBREVIATE_NUMBER(value, 2),
  },
  {
    id: "MAPPED_TABLE",
    label: "Mapped Table Name",
    minWidth: 170,
    align: "left",
  },
  {
    id: "mappedTableColumn",
    label: "Column",
    minWidth: 170,
    align: "left",
  },
  {
    id: "SUM_IN_MAPPED_TABLE",
    label: "Sum",
    minWidth: 100,
    align: "left",
    format: (value: number) => ABBREVIATE_NUMBER(value, 2),
  },
  {
    id: "MATCHED_VOULME",
    label: "Matched Volume %",
    minWidth: 100,
    align: "center",
    format: (value: number) => value.toFixed(1),
  },
  {
    id: "QC_STATUS",
    label: "QC Status",
    minWidth: 100,
    align: "left",
  },
]

function createData({
  BASE_TABLE,
  baseTableColumn,
  SUM_IN_BASE_TABLE,
  MAPPED_TABLE,
  mappedTableColumn,
  SUM_IN_MAPPED_TABLE,
  MATCHED_VOULME,
  QC_STATUS,
}: ICCTableData): ICCTableData {
  return {
    BASE_TABLE,
    baseTableColumn,
    SUM_IN_BASE_TABLE,
    MAPPED_TABLE,
    mappedTableColumn,
    SUM_IN_MAPPED_TABLE,
    MATCHED_VOULME,
    QC_STATUS,
  }
}
const ResultDiv = styled.div`
  height: 25px;
  width: 70px;
  display: inline-block;
  padding: 2px 10px;
  border-radius: 5px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PassDiv = styled(ResultDiv)`
  background-color: #27af8d;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FailedDiv = styled(ResultDiv)`
  background-color: #fcc;
  font-size: "14px";
  background: #da1818;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`
export default function CCTable() {
  const [page, setPage] = React.useState(0) // Current page in pagination
  const [rowsPerPage, setRowsPerPage] = React.useState(10) // Rows to display per page

  const theme: any = useTheme()
  const classes = useStyles({ theme })
  const [rows, setRows] = React.useState([]) // State to hold rows for the table
  const data: ICCTableData[] = useAppSelector(ccDataSelector) // Get data from Redux store

  console.log(data, "data")

  // Transform incoming data into the format required for the table
  React.useEffect(() => {
    const temp: any = data.map((row) => {
      return createData({
        BASE_TABLE: row["BASE_TABLE"],
        baseTableColumn: row["baseTableColumn"],
        SUM_IN_BASE_TABLE: row["SUM_IN_BASE_TABLE"],
        MAPPED_TABLE: row["MAPPED_TABLE"],
        mappedTableColumn: row["mappedTableColumn"],
        SUM_IN_MAPPED_TABLE: row["SUM_IN_MAPPED_TABLE"],
        MATCHED_VOULME: row["MATCHED_VOULME"] || 99, // Static value for matched volume
        QC_STATUS: row["QC_STATUS"],
      })
    })
    setRows(temp) // Set the transformed rows
  }, [data]) // Dependency on data changes

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage) // Update to the new page
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value) // Update rows per page
    setPage(0) // Reset to the first page
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        width: "100%",
      }}
    >
      <Paper sx={{ width: "100%" }}>
        <TableContainer sx={{ maxHeight: 915 }}>
          <Box
            sx={{
              maxWidth: "100%",
              overflowX: "auto",
              // "@media (min-width: 1000px)": {
              //   maxWidth: "1100px", // Max width for medium to large desktops
              // },
              // "@media (min-width: 1400px)": {
              //   maxWidth: "1260px", // Max width for larger desktops
              // },
              // "@media (min-width: 1500px)": {
              //   maxWidth: "1450px", // Max width for very large desktops
              // },
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead className={classes.root}>
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={1}
                    className={classes.borderRight + " " + classes.borderBottom}
                  >
                    {/* Placeholder for Country column */}
                  </TableCell>
                  <TableCell
                    className={
                      classes.wrapper +
                      " " +
                      classes.borderBottom +
                      " " +
                      classes.borderRight
                    }
                    align="center"
                    colSpan={3}
                  >
                    <div className={classes.heading}> Base Table details</div>
                  </TableCell>
                  <TableCell
                    className={
                      classes.wrapper +
                      " " +
                      classes.borderBottom +
                      " " +
                      classes.borderRight
                    }
                    align="center"
                    colSpan={3}
                  >
                    <div className={classes.heading}> Mapped Table details</div>
                  </TableCell>
                  <TableCell
                    className={
                      classes.wrapper +
                      " " +
                      classes.borderBottom +
                      " " +
                      classes.borderRight
                    }
                    align="center"
                    colSpan={2}
                  >
                    <div className={classes.heading}> Results</div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    key={"id"}
                    align={"left"}
                    className={classes.wrapper + " " + classes.borderRight}
                    sx={{ top: 57, minWidth: 30 }}
                  >
                    <Typography variant="tableHeader"> S.No </Typography>
                  </TableCell>

                  {columns.map((column, i) => (
                    <TableCell
                      key={uuidv4()}
                      align={column.align}
                      className={classes.wrapper}
                      sx={{
                        top: 57,
                        minWidth: column.minWidth,
                        borderRight: i % 3 == 2 ? "1px solid lightgray" : "",
                      }}
                    >
                      <Typography variant="tableHeader">
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Render rows for the current page */}
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        <TableCell
                          align={"left"}
                          className={classes.borderRight}
                        >
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        {/* Render each cell in the row based on columns */}
                        {columns.map((column, i) => {
                          const value = row[column.id] // Get the cell value
                          return (
                            <TableCell
                              className={classes.wrapper}
                              key={column.id}
                              align={column.align}
                              sx={{
                                borderRight:
                                  i % 3 == 2 ? "1px solid lightgray" : "",
                              }}
                            >
                              {renderCellValue(column, value)}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
        {/* Pagination component for navigating through pages */}
        <TablePagination
          rowsPerPageOptions={[10, 20]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  )
}

const renderCellValue = (column: any, value: any) => {
  if (column.id === "matchedVolume") {
    return (
      <Box
        sx={{
          background: "grey",
          height: 25,
          borderRadius: 5,
          color: "white",
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {column.format && typeof value === "number"
          ? column.format(value)
          : value}
      </Box>
    )
  }

  if (column.format && typeof value === "number") {
    return column.format(value)
  }

  if (value === "PASS") {
    return <PassDiv>Pass</PassDiv>
  }

  if (value === "FAIL") {
    return <FailedDiv>Failed</FailedDiv>
  }

  return value
}
